/** Common card-owned factory for persisted "already used this round" markers. */
export function roundMarkerStatus(input) {
    return (context) => context.card.facts[input.fact] === context.round
        ? [Object.freeze({
                id: input.id,
                symbol: input.symbol,
                label: input.label,
                description: input.description ?? `${input.label} уже сработал в этом раунде.`,
                tone: input.tone,
                ...(input.compact === undefined ? {} : { compact: input.compact }),
            })]
        : [];
}
/** Compact public marker for cards whose controller currently fills all three location cells. */
export function fullRoomStatus() {
    return (context) => context.card.cell?.fullyFurnished === true
        ? [Object.freeze({
                id: 'full-room',
                symbol: '▦',
                label: 'Локация заполнена',
                description: 'Все ячейки локации вашей стороны заняты картами.',
                tone: 'positive',
                compact: true,
            })]
        : [];
}
//# sourceMappingURL=statuses.js.map